import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GeoData } from './geo.model';
import { map } from 'rxjs/operators';

@Injectable()
export class GeoIpService {
  private readonly http = inject(HttpClient);

  /**
   * geoIpLookup function makes an HTTP GET request to retrieve geographical data based on the client's IP address.
   *
   * @return {Observable<GeoData>} an observable of GeoData containing geographical information
   */
  geoIpLookup(): Observable<GeoData> {
    return this.http.get<GeoData>('https://ipapi.co/json');
  }

  geoIpLookupV2(): Observable<GeoData> {
    return this.http.get<any>('https://geoapi-hoskes.onrender.com/json.gp').pipe(
      map((response) => ({
        ip: response.hoskes_locplugin_request,
        city: response.hoskes_locplugin_city,
        region: response.hoskes_locplugin_region,
        region_code: response.hoskes_locplugin_regionCode,
        country_code: response.hoskes_locplugin_countryCode,
        country_name: response.hoskes_locplugin_countryName,
        latitude: parseFloat(response.hoskes_locplugin_latitude),
        longitude: parseFloat(response.hoskes_locplugin_longitude),
        timezone: response.hoskes_locplugin_timezone,
        network: '', // Placeholder as the API does not provide this field
        version: '', // Placeholder as the API does not provide this field
        continent_code: response.hoskes_locplugin_continentCode,
        continent_name: response.hoskes_locplugin_continentName,
        in_eu: response.hoskes_locplugin_inEUunion === 1,
        accuracy_radius: parseInt(response.hoskes_locplugin_locationAccuracyRadius, 10),
        country: '', // Placeholder
        country_code_iso3: '', // Placeholder
        country_capital: '', // Placeholder
        country_tld: '', // Placeholder
        population: 0, // Placeholder
        currency: '', // Placeholder
        currency_name: '', // Placeholder
        languages: '', // Placeholder
        asn: '', // Placeholder
        org: '', // Placeholder
        postal: '', // Placeholder
        utc_offset: '', // Placeholder
        country_calling_code: '', // Placeholder
        country_area: 0, // Placeholder
        country_population: 0, // Placeholder
      }))
    );
  }
}
